<template>
  <span>

    <button class="btn btn-light"
            @click="showCreateValidationModal"
            v-if="!getClient.parent || (getClient.parent && object.partition)"
            :qid="'validations-create-button-' + type"
            :id="scope"
    >
      <font-awesome-icon icon="check-double"/> {{ $t('validations.create.button_label') }}
    </button>


    <!-- Validation create modal template -->
    <b-modal ref="create-validation" hide-footer>
      <div class="d-block text-center">
        <h4 qid="create-validation-title">
          {{ $t('validations.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-validation-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="createValidationFormSubmit" qid="create-validation-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-validation-status-label">
              {{ $t('validations.create.status_label') }}
            </label>
            <b-form-radio-group
              v-model="validationForm.validation"
              :options="validationOptions"
              :required="true"
              qid="create-validation-status"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-group>
            <label qid="create-validation-comment-label">
              {{ $t('validations.create.comment_label') }}
            </label>
            <b-form-textarea
              qid="create-validation-comment"
              v-model="validationForm.comment"
              rows="6"
              :required="true"
              max-rows="6"
              :placeholder="$t('validations.create.comment_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group v-if="checklist">
            <label qid="create-validation-checklist-label">
              {{ $t('validations.create.checklist_label') }}
            </label>
            <br>
            <div v-for="(value,key) in checklist">
              <p class="mt-2">
                {{ $t('validations.checklist.' + $options.filters.slugify(key)) }}
              </p>
              <div v-for="item in value" class="row">
                <div class="col-sm-6">
                  <p class="text-normal smaller" :class="{'text-muted': disabledArray && disabledArray.indexOf(item.title) > -1}">
                    {{ $t('validations.checklist.' + $options.filters.slugify(item.title)) }}
                  </p>
                </div>
                <div class="col-sm-6 text-right" v-if="validationForm.checklist[key]">
                  <b-form-radio-group
                    :disabled="disabledArray && disabledArray.indexOf(item.title) > -1"
                    v-model="validationForm.checklist[key][item.title]"
                    :options="checklistOptions"
                    qid="create-validation-appropriate-measures"
                  ></b-form-radio-group>
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group>
            <label qid="create-tp-attachments-label">
              {{ $t('validations.create.attachments_label') }}
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </label>
            <br>
            <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
            <label class="btn btn-secondary cursor-pointer" qid="validations-attachments-button">
              <input type="file"
                     name="fileupload"
                     value="fileupload"
                     multiple
                     id="file-validation"
                     @change="onFileChange"
                     @click="resetFile"
              >
              <span>
                <font-awesome-icon icon="cloud-upload-alt" />
                {{ $t('system.upload') }}
              </span>
            </label>
          </b-form-group>
          <b-form-group>
            <label qid="validations-link-label">
              {{ $t('validations.create.links_label') }}
            </label>
            <p v-for="(link, index) in validationForm.links">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeLinkItem(index)"
                    qid="validations-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
            </p>
            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="handleLink"
                  qid="validations-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
            </span>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateValidationModal"
                    qid="edit-validation-cancel-button"
          >
            {{ $t('validations.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-validation-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('validations.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </span>
</template>

<script>
  import {initialsAvatarUrl} from '@/util/userAvatar.js';
  import piincHttp from '@/util/configureAxios.js'
  import {config} from '@/config.js'

  export default {
    name: 'ValidationForm',
    props: {
      object: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: false
      },
      checklist: {
        type: [Array, Object]
      },
      disabledItems: {
        type: Array
      },
      scope: {
        type: String
      }
    },
    data: function() {
      return {
        tableItems: [],
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        itemToDelete: {},
        itemToView: {},
        validationForm: {
          validation: '',
          comment: '',
          links: [],
          checklist: {
          }
        },
        validationOptions: [
          {text: this.$t('validations.create.status_accepted'), value: true},
          {text: this.$t('validations.create.status_rejected'), value: false},
        ],
        checklistOptions: [
          {text: this.$t('system.yes'), value: 'Yes'},
          {text: this.$t('system.no'), value: 'No'},
          {text: this.$t('system.n_a'), value: 'N/A'},
        ],
        error: '',
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        loading: true,
        disabledArray: [],
        buttonDisabled: false
      }
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      checklist: function (options) {
        if (options) {
          // Set all checklist sections to empty objects
          // We need this so we can later dynamically assign models in multidimensional array
          for (var option in options) {
            this.validationForm.checklist[option] = {}
          }
        }
      },
      disabledItems: function (items) {
        this.disabledArray = items
      }
    },
    methods: {
      onFileChange() {
        let files = document.querySelector('#file-validation');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      resetFile() {
        let imagefile = document.querySelector('#file-validation');
        imagefile.value = '';
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.validationForm.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.validationForm.links.splice(index, 1);
      },
      createValidationFormSubmit(evt) {
        let formData = new FormData();
        let files = document.querySelector('#file-validation');
        let sizeError = false;

        // Call handle link function to gather link from link input
        this.handleLink()

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        // Append list of attachments to FormData
        for (var i = 0; i < files.files.length; i++) {
          // Equal to 10 MB
        if (files.files[i].size > 10485760) {
          sizeError = true;
        }
          formData.append("files[]", files.files[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.validationForm.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.validationForm.links[i]));
        }

        formData.append("validation", this.validationForm.validation ? 1 : 0)
        formData.append("comment", this.validationForm.comment)


        if (this.validationForm.checklist) {
          formData.append("checklist", JSON.stringify(this.validationForm.checklist))
        }
        formData.append("type", this.type)
        formData.append("model_type", this.object.who_am_i)
        formData.append("model_id", this.object.id)

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          this.buttonDisabled = true;
          piincHttp.post('validations', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$emit('validationModalClose');
            self.hideCreateValidationModal();
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('validations.create.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors['files.0']) {
                self.error += ' ' + error.data.errors['files.0'][0]
              }
            }
          })
        }
      },
      showCreateValidationModal(object) {
        this.validationForm.validation = '';
        this.validationForm.comment = '';
        if (this.checklist) {
          // Set all checklist sections to empty objects
          // We need this so we can later dynamically assign models in multidimensional array
          for (var option in this.checklist) {
            this.validationForm.checklist[option] = {}
          }
        }
        this.validationForm.links = [];
        this.error = '';
        this.selectedFiles = [];
        this.$refs['create-validation'].show()
      },
      hideCreateValidationModal() {
        this.validationForm.checklist = {}
        this.$refs['create-validation'].hide()
      },
      getUserAvatar(user){
        if (user && user.avatar) {
          return user.avatar;
        } else {
          return initialsAvatarUrl(user);
        }
      },
    },
    created () {

    }
  }
</script>
